"use client";

import { Popup, Button as ButtonItem, Label, Icon } from "semantic-ui-react";

export default function FollowNeighborButton({
  loggedin,
  isMobile,
  onSubscribebtnClick,
}) {
  if (loggedin) return null;

  return (
    <Popup
      size="small"
      position="bottom left"
      on="hover"
      disabled={isMobile}
      trigger={
        <ButtonItem
          as="div"
          labelPosition="right"
          floated="right"
          onClick={() => onSubscribebtnClick("nh")}
          className="theme_red btn_red"
        >
          {isMobile ? (
            <Icon
              name="heart"
              style={{
                margin: "-3px 0px 0px 0px",
                fontSize: "21px",
                color: "rgb(15, 20, 67)",
              }}
            />
          ) : (
            <>
              <ButtonItem className="btn_bg_static btn_alert" background="red">
                <img
                  src={
                    process.env.NEXT_PUBLIC_CDN_ID +
                    "static/images/rsz_alerticon-removebg-preview.png"
                  }
                  width="15px"
                  alt="follow neighborhood"
                  title="follow neighborhood"
                />
              </ButtonItem>
              <Label
                as="a"
                name="saveNeighbor"
                content={
                  isMobile
                    ? "Follow this Neighborhood"
                    : "Follow this Neighborhood"
                }
                basic
                pointing="left"
                className="theme_red btn_red track_button_satic"
              />
            </>
          )}
        </ButtonItem>
      }
    >
      Receive an email when this neighborhood has new listings, score/ranking
      changes, new comments/questions, and more.
    </Popup>
  );
}
